const ServiceOrderSituations = () => import('./pages/situations/pages/ServiceOrderSituations.vue');
const ServiceOrderSituationsForm = () =>
  import('./pages/situations/pages/ServiceOrderSituationsForm.vue');
const ServiceOrderIdentifiers = () =>
  import('./pages/identifiers/pages/ServiceOrderIdentifiers.vue');
const ServiceOrderObjects = () => import('./pages/objects/pages/ServiceOrderObjects.vue');
const ServiceOrderObjectsForm = () => import('./pages/objects/pages/ServiceOrderObjectsForm.vue');

export default [
  {
    path: '/inventory/os/situations',
    name: 'ServiceOrderSituations',
    component: ServiceOrderSituations,
    meta: {
      title: 'Situações',
    },
  },
  {
    path: '/inventory/os/situations/new',
    name: 'ServiceOrderSituationsRegister',
    component: ServiceOrderSituationsForm,
    meta: {
      title: 'Nova Situação',
    },
  },
  {
    path: '/inventory/os/situations/edit/:id',
    name: 'ServiceOrderSituationsEdit',
    component: ServiceOrderSituationsForm,
    meta: {
      title: 'Editar Situação',
    },
  },
  {
    path: '/inventory/os/identifiers',
    name: 'ServiceOrderIdentifiers',
    component: ServiceOrderIdentifiers,
    meta: {
      title: 'Identificadores',
    },
  },
  {
    path: '/inventory/os/objects',
    name: 'ServiceOrderObjects',
    component: ServiceOrderObjects,
    meta: {
      title: 'Objetos',
    },
  },
  {
    path: '/inventory/os/objects/new',
    name: 'ServiceOrderObjectsRegister',
    component: ServiceOrderObjectsForm,
    meta: {
      title: 'Novo Objeto',
    },
  },
  {
    path: '/inventory/os/objects/edit/:id',
    name: 'ServiceOrderObjectsEdit',
    component: ServiceOrderObjectsForm,
    meta: {
      title: 'Editar Objeto',
    },
  },
];
